import { h } from 'preact';
import { useEffect, useState, useRef } from 'preact/hooks';
import classNames from 'classnames';
import Keyboard from 'simple-keyboard';
import style from './style.css';


const type="EmailWidget";

export default function EmailWidget() {

  const [emailValue, setEmailValue] = useState('');
  const emailValueRef = useRef('');
  const emailFieldRef = useRef();
  const keyBoardRef = useRef();

  useEffect(() => {
    function onKeyPress(button) {
      if (button !== '{bksp}') {
        const newValue = `${emailValueRef.current}${button}`;
        emailValueRef.current = newValue
        setEmailValue(newValue);
        setTimeout(() => {
          emailFieldRef.current.focus();
        }, 0);
      } else {
        if (emailValueRef.current.length > 0) {
          const newValue = emailValueRef.current.substring(0, emailValueRef.current.length - 1);
          emailValueRef.current = newValue
          setEmailValue(newValue);
        }
        setTimeout(() => {
          emailFieldRef.current.focus();
        }, 0)
      }
    }

    if (!keyBoardRef.current) {
      const keyboard = new Keyboard({
        onKeyPress: button => onKeyPress(button),
        layout: {
          default: [
            '1 2 3 4 5 6 7 8 9 0',
            'Q W E R T Y U I O P',
            'A S D F G H J K L @',
            'Z X C V B N M . - _',
            '{bksp}'
          ]
        },
        theme: "hg-theme-default hg-layout-numeric numeric-theme"
      });
      keyBoardRef.current = keyboard;
    }

  }, []);

  const renderFields = () => {
    return (
      <div class={style.fieldsContainer}>
        <div class={style.fields}>
          <input
            type="text"
            class={style.emailField}
            minlength="4"
            maxlength="50"
            size="35"
            value={emailValue}
            ref={emailFieldRef}
          />
        </div>
      </div>
    );
  };

  const renderKeyboard = () => {
    return (
      <div class={style.keyboardContainer}>
        <div class={style.keyboard}>
          <div className={classNames('simple-keyboard')} />
        </div>
      </div>
    );
  };

  return (
    <>
      <div class={style.header}>
        <div class={style.title}>Update Email Address</div>
      </div>
      {renderFields()}
      {renderKeyboard()}
    </>
  );
}

EmailWidget.create = function(options = {}) {

  return {
     ...options
  };
};

EmailWidget.type = type;
EmailWidget.label = 'Email Address';
EmailWidget.keyed = true;